<!-- @format -->

@if (activeOiliPayments.length === 0 && activeTuitionFeePayments.length === 0) {
  <div class="guidance">
    {{ "PROFILE.PAYMENTS.TABLE.NO_PAYMENTS" | translate }}
  </div>
}
@if (activeOiliPayments.length > 0) {
  <app-oili-payments-table
    [payments]="activeOiliPayments"
    [caption]="'PROFILE.PAYMENTS.COMMON_PAYMENTS' | translate"
    data-cy="current-and-future-payments-table">
  </app-oili-payments-table>
}
@if (invalidatedOiliPayments.length > 0) {
  <div class="invalidated-payments">
    <sis-expandable [variant]="'link'" [title]="'PROFILE.PAYMENTS.INVALIDATED_COMMON_PAYMENTS' | translate" [level]="level">
      <ng-template sisExpandableContent>
        @if (invalidatedOiliPayments.length > 0) {
          <app-oili-payments-table
            [payments]="invalidatedOiliPayments"
            [caption]="'PROFILE.PAYMENTS.INVALIDATED_COMMON_PAYMENTS' | translate">
          </app-oili-payments-table>
        }
      </ng-template>
    </sis-expandable>
  </div>
}
@if (activeTuitionFeePayments.length > 0) {
  <app-tuition-fee-payments-table [payments]="activeTuitionFeePayments" [caption]="'PROFILE.PAYMENTS.TUITION_FEE_PAYMENTS' | translate">
  </app-tuition-fee-payments-table>
}
@if (invalidatedTuitionFeePayments.length > 0) {
  <div class="invalidated-payments">
    <sis-expandable [variant]="'link'" [title]="'PROFILE.PAYMENTS.INVALIDATED_TUITION_FEE_PAYMENTS' | translate" [level]="level">
      <ng-template sisExpandableContent>
        @if (invalidatedTuitionFeePayments.length > 0) {
          <app-tuition-fee-payments-table
            [payments]="invalidatedTuitionFeePayments"
            [caption]="'PROFILE.PAYMENTS.INVALIDATED_TUITION_FEE_PAYMENTS' | translate">
          </app-tuition-fee-payments-table>
        }
      </ng-template>
    </sis-expandable>
  </div>
}
